import React, { useEffect } from 'react'
import SearchFilters from './SearchFilters/SearchFilters'
import SearchResults from './SearchResults/SearchResults'
import styles from './styles.module.css'

export default function ProductDR () {
  useEffect(() => {
    localStorage.setItem('dfp/dataTypeNavigation', 'product')
    document.title = 'Datafiniti Portal | Product'
    window.scrollTo(0, 0)
  }, []) /* eslint-disable-line react-hooks/exhaustive-deps */

  return (
    <div className={styles.mainContainerProduct}>
      <SearchFilters />
      <SearchResults />
    </div>
  )
}
